"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _signUpModule = _interopRequireDefault(require("../styles/sign-up.module.css"));

var _Icons = require("./Icons");

var _Loader = require("./Loader");

var _constant = require("./constant");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OtpVerification =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OtpVerification, _React$Component);

  function OtpVerification(props) {
    var _this;

    _classCallCheck(this, OtpVerification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OtpVerification).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "verify", function (e) {
      e.preventDefault();

      _this.setState({
        verifying: true,
        error: false
      });

      var formData = new FormData(e.target);
      fetch("".concat(_constant.API_ROOT, "verifyotp.php"), {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          _this.props.onSuccess(data.uid);
        } else {
          _this.setState({
            verifying: false,
            error: true
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resendOtp", function () {
      _this.setState({
        resending: true
      });

      var formData = new FormData();
      formData.append("number", _this.state.phone);
      formData.append("countryCode", _this.state.countryCode);
      fetch("".concat(_constant.API_ROOT, "resendotp.php"), {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        _this.setState({
          resending: false
        });
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "otpOnChange", function (e) {
      var value = e.target.value;
      var re = new RegExp("^\\d+$", "g");

      if (re.test(value)) {
        _this.setState({
          otp: value
        });
      }
    });

    _this.state = {
      error: false,
      resending: false,
      verifying: false,
      otp: "",
      phone: props.phone,
      countryCode: props.countryCode
    };
    return _this;
  }

  _createClass(OtpVerification, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          verifying = _this$state.verifying,
          resending = _this$state.resending,
          phone = _this$state.phone,
          countryCode = _this$state.countryCode,
          otp = _this$state.otp;
      var _this$props = this.props,
          back = _this$props.back,
          onSuccess = _this$props.onSuccess;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.backButton,
        onClick: back
      }, _react.default.createElement(_Icons.BackArrow, {
        width: "0.875rem"
      }), _react.default.createElement("span", null, "Back")), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentBetween, " ").concat(_signUpModule.default.resendHeader)
      }, _react.default.createElement("div", {
        className: _baseModule.default.heading2
      }, "Verification"), _react.default.createElement("button", {
        onClick: this.resendOtp,
        disabled: resending
      }, resending ? _react.default.createElement(_Loader.ButtonLoader, {
        size: "0.875rem",
        color: "#fdcd26"
      }) : "Resend code")), _react.default.createElement("p", {
        className: _baseModule.default.small
      }, "Provide the verification code sent to your contact", _react.default.createElement("span", {
        className: _baseModule.default.bold
      }, "\xA0", "+".concat(countryCode, " ").concat(phone))), _react.default.createElement("form", {
        className: _baseModule.default.container,
        onSubmit: this.verify
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, "Incorrect OTP. Try again")) : "", _react.default.createElement("input", {
        type: "hidden",
        name: "number",
        value: phone
      }), _react.default.createElement("input", {
        type: "hidden",
        name: "countryCode",
        value: countryCode
      }), _react.default.createElement("input", {
        type: "text",
        name: "otp",
        value: otp,
        onChange: this.otpOnChange,
        placeholder: "Enter the code",
        className: _formFiledModule.default.input,
        required: true
      }), _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block),
        disabled: verifying
      }, verifying ? _react.default.createElement(_Loader.ButtonLoader, null) : "Verify")));
    }
  }]);

  return OtpVerification;
}(_react.default.Component);

var _default = OtpVerification;
exports.default = _default;